import { Entity } from '../entity';

export class Cloth {
  static update(entities: Entity[]): void {
    entities.forEach((entity) => entity.tryGetComponent('CLOTH')?.update());
  }
}
